






import { MrfiktivReferenceGen } from "@/services/mrfiktiv/v1/data-contracts";
import { Component, Prop } from "vue-property-decorator";
import Tooltip from "../utility/tooltip.vue";
import SharedContentMixin from "./SharedContentMixin.vue";
import { ResourceEnum } from "@/store/enum/authResourceEnum";

@Component({
  components: { Tooltip }
})
export default class SharedContentCardRefTypes extends SharedContentMixin {
  @Prop()
  reference!: MrfiktivReferenceGen;

  get icon() {
    return this.getIcon(this.reference?.refType as ResourceEnum);
  }
}
